<template>
  <div>
    <div class="bg-grey-lighter text-center my-4 p-4">
      <h1 class="uppercase text-lg font-extrabold p-2">Private & Confidential</h1>
      <div>
        Welcome to your Annual Review Meeting! The purpose of your Annual Review Meeting is to review your Fine & Country business, celebrate successes, give, and
        receive feedback, and establish if and where we can best support you in excelling with the F&C brand. Part of the meeting will be to review the Member Standards
        which comprise of the 'annual performance indicators' set by the National Advisory Council, and Head Office 'performance review matrices' which includes market share
        analysis across the territory, engagement with the head office tools, including investment in marketing, and building the F&C brand across the territory whilst adhering
        to 'Brand Guidelines'.
      </div>
    </div>
    <div class="text-xl font-black py-2 mt-8">1. Performance Review</div>
    <div class="font-black py-2">Performance Matrices</div>
    <div class="flex w-full items-center">
      <div class="flex-1/3 px-4">
        <div class="py-2">Competitive Landscape Report. Insight data for your Region and F&C 'Upper Quartile' price point.</div>
        <panel class="img-div" v-if="form.attachment && form.attachment.region_landscape_img">
          <img :src="form.attachment.region_landscape_img" class="w-full pb-2 object-cover bg-gray-100 cursor-pointer" @click="LandscapeImgVisible=true" />
          <modal v-if="LandscapeImgVisible" @leave="LandscapeImgVisible=false" modalClass="max-width-full">
            <img :src="form.attachment.region_landscape_img" />
          </modal>
        </panel>
        <panel v-else>
          <div>
            <img src="https://via.placeholder.com/400x200.png?text=No+region+lanscape+image">
          </div>
        </panel>
      </div>
      <div class="flex-1/3 px-4">
        <div class="py-2">Competitive Landscape Report. Insight data for your postcode territories and F&C 'Upper Quartile' price point.</div>
        <panel class="img-div" v-if="form.attachment && form.attachment.territory_landscape_img">
          <img :src="form.attachment.territory_landscape_img" class="w-full pb-2 object-cover bg-gray-100 cursor-pointer" @click="TerritoryImgVisible=true" />
          <modal v-if="TerritoryImgVisible" @leave="TerritoryImgVisible=false" modalClass="max-width-full">
            <img :src="form.attachment.territory_landscape_img" />
          </modal>
        </panel>
        <panel v-else>
          <div>
            <img src="https://via.placeholder.com/400x200.png?text=No+postcode+territories+lanscape+image">
          </div>
        </panel>
      </div>
    </div>
    <!-- Sub section -->
    <div class="mt-8 pt-2">
      <div class="font-black text-lg py-2">Current Market conditions and activity</div>
      <div v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
        <review-question-component v-model="form.questions[page][sectionStart][index]" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'

export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value,
      errors: [],
      LandscapeImgVisible: false,
      TerritoryImgVisible: false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
  .img-div{
    width: 80%;
    border: 2px dotted grey;
  }
</style>
